import { useSyncExternalStore } from "react";

/**
 * soremon パネルの開閉と、soremon の状態（mood。体験仕様「15. 基本状態」）を
 * 共有する小さなストア。
 *
 * 開閉ボタン（キャラクター）はページごとにマウントし直される GlobalHeader 内、
 * パネル本体（SoremonPanel）は App 直下に置くため、両者で共有する（画面遷移しても
 * パネルを開いたままにし、パネルが決めた状態をヘッダーのキャラクターにも映す）。
 */
export type SoremonMood =
  | "idle"
  | "listening"
  | "thinking"
  | "acting"
  | "asking"
  | "completed"
  | "error";

let open = false;
let mood: SoremonMood = "idle";
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const notify = () => listeners.forEach((listener) => listener());

export const setSoremonPanelOpen = (next: boolean) => {
  if (open === next) return;
  open = next;
  notify();
};

export const useSoremonPanelOpen = (): boolean =>
  useSyncExternalStore(subscribe, () => open);

export const setSoremonMood = (next: SoremonMood) => {
  if (mood === next) return;
  mood = next;
  notify();
};

export const useSoremonMood = (): SoremonMood =>
  useSyncExternalStore(subscribe, () => mood);
